<!--
  商店
  lovi 2020-06-17
-->
<template>
  <div class="w100" :class="{ order: curTab == 0 }">
    <store-header :searchFlag.sync="searchFlag" :type="1" />
    <store-info
      :data="storeInfo"
      :coupon="couponData"
      :couponFlag.sync="couponFlag"
      @receiveCoupons="receiveCoupons"
    />
    <van-tabs ref="tabs" v-model="curTab" sticky>
      <van-tab :title="$t('life.order')">
        <tab-order
          :taboffsetH.sync="taboffsetH"
          :list="shopList"
          :tabOffsetT="tabOffsetT"
        />
      </van-tab>
      <van-tab :title="$t('life.evaluate')">
        <tab-evaluate />
      </van-tab>
      <van-tab :title="$t('life.merchant')">
        <tab-merchant :data="storeInfo" />
      </van-tab>
    </van-tabs>
    <div style="display:none">{{ shopCount }}</div>
    <!-- 购物车 -->
    <shop-cart
      v-if="curTab == 0 && storeInfo.shop_name"
      :activity="couponData.activity"
    />
    <!-- 商品搜索 -->
    <transition name="slide">
      <product-search
        v-if="searchFlag"
        :shopId.sync="shopId"
        :searchFlag.sync="searchFlag"
        :type="1"
      />
    </transition>
    <!-- 商家优惠券 -->
    <store-coupon
      :couponFlag.sync="couponFlag"
      :shopId.sync="shopId"
      :data="couponData"
      @receiveCoupons="receiveCoupons"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import StoreHeader from "@/components/life/header";
import StoreInfo from "@/components/life/header/info";
import TabOrder from "./tab/order";
import TabEvaluate from "./tab/evaluate";
import TabMerchant from "./tab/merchant";
import ShopCart from "@/components/life/shopCart";
import ProductSearch from "../search";
import StoreCoupon from "./coupon";
export default {
  name: "store",
  meta: {
    keepAlive: true,
    service: false // 客服
  },
  components: {
    StoreHeader,
    StoreInfo,
    TabOrder,
    TabEvaluate,
    TabMerchant,
    ShopCart,
    ProductSearch,
    StoreCoupon
  },
  data() {
    return {
      shopId: "", // 商家ID
      storeInfo: {}, //商家信息
      curTab: 0, //tabindex
      list: [],
      shopList: [],
      couponFlag: false, //优惠券Flag
      couponData: {},
      searchFlag: false, //搜索FLag
      taboffsetH: 0, //tab菜单高度
      tabOffsetT: 0
    };
  },
  created() {
    this.shopId = this.$route.query.shopId;
    // this.initializeData(this.shopCartData);
    this.getTopStoreInfomation();
    this.getStoreProductInfo();
    this.getDisccountStoreInfomation();
  },
  mounted() {},
  computed: {
    ...mapGetters(["shopCartData", "againOrder"]),
    shopCount() {
      // 商品分类统计
      let vm = this;
      let arr = [];
      arr = vm.list;
      for (let i = 0; i < vm.list.length; i++) {
        arr[i].count = 0;
        vm.$set(vm.shopList[i], "count", arr[i].count);
        for (let j = 0; j < vm.shopCartData.length; j++) {
          if (vm.shopCartData[j].class_id == vm.list[i].class_id) {
            arr[i].count += vm.shopCartData[j].count;
            vm.$set(vm.shopList[i], "count", arr[i].count);
          }
        }
      }
      return arr;
    }
  },
  methods: {
    initializeData(arr, again) {
      // 初始化数据
      console.log("initializeData", arr, again);
      let vm = this;
      vm.shopList = JSON.parse(JSON.stringify(vm.list));
      if (!arr.length) {
        return;
      }
      for (let i = 0; i < vm.shopList.length; i++) {
        for (let j = 0; j < vm.shopList[i].product.length; j++) {
          for (let k = 0; k < arr.length; k++) {
            if (arr[k].product_id == vm.shopList[i].product[j].product_id) {
              if (again == 1) {
                // 再来一单
                let obj = vm.shopList[i].product[j];
                let count = 0;
                if (obj.stock < arr[k].count) {
                  count = obj.stock;
                } else {
                  count = arr[k].count;
                }
                obj.count = count;
                vm.$store.dispatch("SET_SHOPCART_DATA", obj);
                vm.$set(vm.shopList[i].product[j], "count", count);
              } else {
                vm.$set(vm.shopList[i].product[j], "count", arr[k].count);
              }
            }
          }
        }
      }
    },
    getStoreProductInfo() {
      // 店铺商品信息
      let vm = this;
      vm.$post(
        "/app/store/getStoreProductInfo",
        { shop_id: vm.shopId },
        {
          loading: true
        }
      ).then(res => {
        console.log("getStoreProductInfo", res);
        vm.list = res.list;
        vm.shopList = JSON.parse(JSON.stringify(vm.list));
        if (vm.againOrder.length) {
          // 再来一单
          vm.initializeData(vm.againOrder, 1);
          vm.$store.dispatch("SET_AGAIN_ORDER", "delete");
          return;
        }
        if (vm.shopCartData.length) {
          // 购物车
          if (vm.shopId != vm.shopCartData[0].shopId) {
            vm.$store.dispatch("SET_SHOPCART_DATA", "delete");
          }
          vm.initializeData(vm.shopCartData);
        }
      });
    },
    getTopStoreInfomation() {
      // 获取店铺信息
      let vm = this;
      vm.$post(
        "/app/store/getTopStoreInfomation",
        { shop_id: vm.shopId },
        { loading: true }
      ).then(res => {
        console.log("getTopStoreInfomation", res);
        vm.storeInfo = res.list;
        localStorage.setItem("storeInfo", JSON.stringify(res.list));

        this.$nextTick(() => {
          this.taboffsetH = this.$refs.tabs.$el.children[0].offsetHeight;
          this.tabOffsetT = this.$refs.tabs.$el.offsetTop;
          console.log(
            "taboffsetH:",
            this.taboffsetH,
            "tabOffsetT:",
            this.tabOffsetT
          );
        });
      });
    },
    receiveCoupons(id) {
      // 领取优惠券
      let vm = this;
      let params = {};
      params.coupon_id = id;
      vm.$post("/app/store/receiveCoupons", params, {
        loading: true,
        alert: true
      }).then(res => {
        console.log("receiveCoupons", res);
        vm.$toast(res.msg);
        if (res.code == 0) {
          vm.getDisccountStoreInfomation();
        }
      });
    },
    getDisccountStoreInfomation() {
      //店铺优惠信息
      let vm = this;
      let params = {};
      params.shop_id = vm.shopId;
      vm.$post("/app/store/getDisccountStoreInfomation", params, {
        loading: true
      }).then(res => {
        console.log("getDisccountStoreInfomation", res);
        vm.couponData = res.list;
      });
    }
  },
  watch: {
    shopCartData: {
      handler: function(arr) {
        console.log("store.shopCartData", arr);
        this.initializeData(arr);
      },
      deep: true
    }
  }
};
</script>

<style lang="less" scoped>
.order {
  padding-bottom: 50px;
}
/deep/.van-tabs__nav {
  .van-tab {
    font-size: 16px;
  }
  .van-tabs__line {
    background: #2387ff;
  }
}
</style>
